import { ResponseModelInterfaceStatic } from "@/service/models/response-model-interface";
import { staticImplements } from "@/utilities/static-implements";
import { XmlElementWrapper } from "@/utilities/xml-helpers/xml-element-wrapper";
import { StdAprioriValue } from "../../drug-common/std-apriori-value";

@staticImplements<ResponseModelInterfaceStatic>()
export class DosageValuesRange
{
    public constructor(
        public from : StdAprioriValue,
        public to : StdAprioriValue,
        public step : StdAprioriValue,
    )
    {
    }

    public static makeFromXml(elem: XmlElementWrapper): DosageValuesRange
    {
        return new this(
            StdAprioriValue.makeFromXml(elem.firstChildByTag("from")),
            StdAprioriValue.makeFromXml(elem.firstChildByTag("to")),
            StdAprioriValue.makeFromXml(elem.firstChildByTag("step")),
        );
    }

    public get values() : number[]
    {
        const values = [];

        const startValue = this.from.value;
        const endValue = this.to.value;
        const stepValue = this.step.value;

        for (let currentValue = startValue; currentValue <= endValue; currentValue += stepValue) {
            values.push(currentValue);
        }

        return values;
    }
}
